import { useCallback, useEffect, useRef, useState } from 'react'
import { Box } from '@ui'

type Props = {
    imageUrl: string | undefined
}

export const ImagePreview = ({ imageUrl }: Props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const imgRef = useRef<HTMLImageElement>(null)

    const onLoad = useCallback(() => {
        setIsLoaded(true)
    }, [])

    const onError = useCallback(() => {
        setIsLoaded(false)
    }, [])

    useEffect(() => {
        if (imageUrl) {
            setIsLoaded(false)
            if (imgRef.current?.complete && imgRef.current.naturalHeight > 0) {
                setIsLoaded(true)
            }
        }
    }, [imageUrl])

    return (
        <>
            <Box
                style={{
                    backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    opacity: isLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                }}
                width="100%"
                height="100%"
            />
            {/* loader */}
            {!imageUrl ? null : (
                <Box
                    as="img"
                    position="absolute"
                    src={imageUrl}
                    opacity="transparent"
                    width="1"
                    height="1"
                    objectFit="cover"
                    ref={imgRef}
                    onLoad={onLoad}
                    onError={onError}
                />
            )}
        </>
    )
}
